import { useContext } from 'react';
import { EditorCanvasContext } from '../editor-canvas-context';

export const useEditorCanvas = () => {
  const context = useContext(EditorCanvasContext);
  if (!context) {
    throw new Error('useEditorCanvas debe usarse dentro de EditorCanvasProvider');
  }
  return context;
};
